module.exports = __webpack_public_path__ + "static/media/xplogo-login.dbdcb00d.svg";